import * as Sentry from '@sentry/vue'

/**
 * Оборачивает async-функцию в Sentry-спан.
 * Если есть активная транзакция — спан становится дочерним.
 * Если нет — создаётся новая корневая транзакция.
 *
 * @param {string} name — имя спана, например 'GET /init'
 * @param {() => Promise<T>} fn — async-функция с HTTP-запросом
 * @returns {Promise<T>}
 */
export function traceRequest(name, fn) {
  return Sentry.startSpan({ name, op: 'http.client' }, fn)
}
